export default "__VITE_ASSET__DT8Lhjb1__"